import type { ContactMethod } from '../types/contactTypes';

export default function ContactInfoCard({ icon: Icon, label, value, subtext, href, external }: ContactMethod) {
  const content = (
    <div className="bg-card dark:bg-panel/80 p-6 rounded-lg shadow-surface flex items-start">
      <div className="mr-4 mt-1">
        <Icon className="text-secondary text-2xl" />
      </div>
      <div>
        <span className="text-theme-secondary text-xs tracking-wider uppercase block mb-1">
          {label}
        </span>
        <p className="font-bold text-primary dark:text-theme-primary mb-1">{value}</p>
        <p className="text-sm text-theme-secondary">{subtext}</p>
      </div>
    </div>
  );

  if (href) {
    return (
      <a
        href={href}
        target={external ? '_blank' : undefined}
        rel={external ? 'noopener noreferrer' : undefined}
        className="block mb-4 last:mb-0"
      >
        {content}
      </a>
    );
  }

  return <div className="mb-4 last:mb-0">{content}</div>;
}
